(function(angular){
	'use strict';
	
	angular
		.module('staticChartModule', [
			'BaseConfig', 
			'highChartsModule',
			'sharedDataVisualizationModule'
		])
		.value('globalConfig', globalConfig);

})(window.angular);